import { SET_SUBSCRIPTION_BUNDLE_SUCCESS } from "./ActionConstant";
import { SET_SUBSCRIPTION_PRICE_START } from "./ActionConstant";
import { SET_SUBSCRIPTION_PRICE_FAILED } from "./ActionConstant";
import { USER_UNSUBSCRIBE_SUCCESS } from "./ActionConstant";
import { BUNDLE_MODAL_OPEN } from "./ActionConstant";
import { BUNDLE_MODAL_CLOSE } from "./ActionConstant";
import { USER_UNSUBSCRIBE_FAILED } from "./ActionConstant";
import { USER_UNSUBSCRIBE_START } from "./ActionConstant";
import { SET_SUBSCRIPTION_PRICE_SUCCESS } from "./ActionConstant";
import { SET_SUBSCRIPTION_BUNDLE_FAILED } from "./ActionConstant";
import { SET_SUBSCRIPTION_BUNDLE_START } from "./ActionConstant";
import {
  FETCH_SUBSCRIPTION_START,
  FETCH_SUBSCRIPTION_SUCCESS,
  FETCH_SUBSCRIPTION_FAILURE,
  FETCH_SINGLE_SUBSCRIPTION_START,
  FETCH_SINGLE_SUBSCRIPTION_SUCCESS,
  FETCH_SINGLE_SUBSCRIPTION_FAILURE,
  SUBSCRIPTION_PAYMENT_STRIPE_START,
  SUBSCRIPTION_PAYMENT_STRIPE_SUCCESS,
  SUBSCRIPTION_PAYMENT_STRIPE_FAILURE,
  SUBSCRIPTION_PAYMENT_WALLET_START,
  SUBSCRIPTION_PAYMENT_WALLET_SUCCESS,
  SUBSCRIPTION_PAYMENT_WALLET_FAILURE,
  SUBSCRIPTION_AUTO_RENEWAL_START,
  SUBSCRIPTION_AUTO_RENEWAL_SUCCESS,
  SUBSCRIPTION_AUTO_RENEWAL_FAILURE,
  SUBSCRIPTION_PAYMENT_PAYPAL_START,
  SUBSCRIPTION_PAYMENT_PAYPAL_SUCCESS,
  SUBSCRIPTION_PAYMENT_PAYPAL_FAILURE,
  FETCH_MY_ACTIVE_SUBSCRIPTION_FAILURE, 
  FETCH_MY_ACTIVE_SUBSCRIPTION_START, 
  FETCH_MY_ACTIVE_SUBSCRIPTION_SUCCESS,
  FETCH_ACTIVE_SUBSCRIBERS_START,
  FETCH_ACTIVE_SUBSCRIBERS_SUCCESS,
  FETCH_ACTIVE_SUBSCRIBERS_FAILURE,
} from "./ActionConstant";

// Get subscription actions.
export function fetchSubscriptionStart(data) {
  return {
    type: FETCH_SUBSCRIPTION_START,
    data,
  };
}

export function fetchSubscriptionSuccess(data) {
  return {
    type: FETCH_SUBSCRIPTION_SUCCESS,
    data,
  };
}

export function fetchSubscriptionFailure(error) {
  return {
    type: FETCH_SUBSCRIPTION_FAILURE,
    error,
  };
}

// Get Active subscriptions
export function fetchMyActiveSubscriptionStart(data) {
  return {
    type: FETCH_MY_ACTIVE_SUBSCRIPTION_START,
    data,
  };
}

export function fetchMyActiveSubscriptionSuccess(data) {
  return {
    type: FETCH_MY_ACTIVE_SUBSCRIPTION_SUCCESS,
    data,
  };
}

export function fetchMyActiveSubscriptionFailure(error) {
  return {
    type: FETCH_MY_ACTIVE_SUBSCRIPTION_FAILURE,
    error,
  };
}

// Get Active subscribers
export function fetchActiveSubscribersStart(data) {
  return {
    type: FETCH_ACTIVE_SUBSCRIBERS_START,
    data,
  };
}

export function fetchActiveSubscribersSuccess(data) {
  return {
    type: FETCH_ACTIVE_SUBSCRIBERS_SUCCESS,
    data,
  };
}

export function fetchActiveSubscribersFailure(error) {
  return {
    type: FETCH_ACTIVE_SUBSCRIBERS_FAILURE,
    error,
  };
}

// Get single subscription actions.

export function fetchSingleSubscriptionStart(data) {
  return {
    type: FETCH_SINGLE_SUBSCRIPTION_START,
    data,
  };
}

export function fetchSingleSubscriptionSuccess(data) {
  return {
    type: FETCH_SINGLE_SUBSCRIPTION_SUCCESS,
    data,
  };
}

export function fetchSingleSubscriptionFailure(error) {
  return {
    type: FETCH_SINGLE_SUBSCRIPTION_FAILURE,
    error,
  };
}

// Subscription Payment stripe actions.

export function subscriptionPaymentStripeStart(data) {
  return {
    type: SUBSCRIPTION_PAYMENT_STRIPE_START,
    data,
  };
}

export function subscriptionPaymentStripeSuccess(data) {
  return {
    type: SUBSCRIPTION_PAYMENT_STRIPE_SUCCESS,
    data,
  };
}

export function subscriptionPaymentStripeFailure(error) {
  return {
    type: SUBSCRIPTION_PAYMENT_STRIPE_FAILURE,
    error,
  };
}

// Subscription Payment wallet actions.

export function subscriptionPaymentWalletStart(data) {
  return {
    type: SUBSCRIPTION_PAYMENT_WALLET_START,
    data,
  };
}

export function subscriptionPaymentWalletSuccess(data) {
  return {
    type: SUBSCRIPTION_PAYMENT_WALLET_SUCCESS,
    data,
  };
}

export function subscriptionPaymentWalletFailure(error) {
  return {
    type: SUBSCRIPTION_PAYMENT_WALLET_FAILURE,
    error,
  };
}

// Subscription auto renewal actions.

export function subscriptionAutoRenewalStart(data) {
  return {
    type: SUBSCRIPTION_AUTO_RENEWAL_START,
    data,
  };
}

export function subscriptionAutoRenewalSuccess(data) {
  return {
    type: SUBSCRIPTION_AUTO_RENEWAL_SUCCESS,
    data,
  };
}

export function subscriptionAutoRenewalFailure(error) {
  return {
    type: SUBSCRIPTION_AUTO_RENEWAL_FAILURE,
    error,
  };
}

// Subscription Payment stripe actions.

export function subscriptionPaymentPaypalStart(data) {
  return {
    type: SUBSCRIPTION_PAYMENT_PAYPAL_START,
    data,
  };
}

export function subscriptionPaymentPaypalSuccess(data) {
  return {
    type: SUBSCRIPTION_PAYMENT_PAYPAL_SUCCESS,
    data,
  };
}

export function subscriptionPaymentPaypalFailure(error) {
  return {
    type: SUBSCRIPTION_PAYMENT_PAYPAL_FAILURE,
    error,
  };
}

//create subscription bundle

export function setSubscriptionBundleStart(data) {
  return {
    type: SET_SUBSCRIPTION_BUNDLE_START,
    data,
  };
}

export function setSubscriptionBundleSuccess(data) {
  return {
    type: SET_SUBSCRIPTION_BUNDLE_SUCCESS,
    data,
  };
}

export function setSubscriptionBundleFailed(error) {
  return {
    type: SET_SUBSCRIPTION_BUNDLE_FAILED,
    error,
  };
}

//set Subscription price

export function setSubscriptionPriceStart(data) {
  return {
    type: SET_SUBSCRIPTION_PRICE_START,
    data,
  };
}

export function setSubscriptionPriceSuccess(data) {
  return {
    type: SET_SUBSCRIPTION_PRICE_SUCCESS,
    data,
  };
}

export function setSubscriptionPriceFailed(error) {
  return {
    type: SET_SUBSCRIPTION_PRICE_FAILED,
    error,
  };
}

//unsubscribe

export function userUnsubscribeStart(data) {
  return {
    type: USER_UNSUBSCRIBE_START,
    data,
  };
}

export function userUnsubscribeSuccess(data) {
  return {
    type: USER_UNSUBSCRIBE_SUCCESS,
    data,
  };
}

export function userUnsubscribeFailed(error) {
  return {
    type: USER_UNSUBSCRIBE_FAILED,
    error,
  };
}

//handle bundle modal

export function openBundleModal() {
  return {
    type: BUNDLE_MODAL_OPEN,
  };
}

export function closeBundleModal() {
  return {
    type: BUNDLE_MODAL_CLOSE,
  };
}
